import { define } from 'wicked-elements';

define('[data-component="service-worker"]', {
  async init() {
    console.log('[ServiceWorkerManager] Initializing...');
    
    if (!('serviceWorker' in navigator)) {
      console.log('[ServiceWorkerManager] Service workers not supported.');
      return;
    }

    try {
      console.log('[ServiceWorkerManager] Registering service worker...');
      const registration = await navigator.serviceWorker.register(new URL('/pwa-service-worker.js', import.meta.url));
      console.log('[ServiceWorkerManager] Service Worker registered successfully.');
      
      this.attachUpdateListener(registration);
    } catch (error) {
      console.error('[ServiceWorkerManager] Service Worker registration failed:', error);
    }
  },

  attachUpdateListener(registration) {
    registration.addEventListener('updatefound', () => {
      console.log('[ServiceWorkerManager] New service worker version found.');
      const newWorker = registration.installing;
      
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          console.log('[ServiceWorkerManager] New worker installed.');
          this.showUpdateNotification();
        }
      });
    });
  },

  showUpdateNotification() {
    // Only show in PWA/standalone mode
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!isStandalone) return;

    // Remove any existing update notification
    const existing = document.querySelector('.gpla-update-banner');
    if (existing) existing.remove();

    // Create and inject the banner
    const notification = document.createElement('div');
    notification.className = 'gpla-update-banner bg-neutral-50 border border-black p-3 flex justify-between gap-4 items-center relative rounded-lg links text-xl';
    notification.innerHTML = `
      <div>
        <p class="font-bold">App updated!</p>
        <p>Refresh to see the latest version.</p>
      </div>
      <button class="ui-button ui-button--sm h-11 text-base border-neutral-400 hover:border-black transition-colors" onclick="window.location.reload()">Refresh</button>
    `;

    const prompts = document.querySelector('.prompts-container');
    if (prompts) {
      prompts.insertBefore(notification, prompts.firstChild);
    } else {
      document.body.appendChild(notification);
    }

    // Auto-hide after 8 seconds
    setTimeout(() => {
      notification.remove();
    }, 8000);
  }
});
